// let customerStyles = require("./assets/custom.css");
// let url = "http://api-adm.dharmap.com";
// let socketurl = "http://api-adm.dharmap.com/api";
// let base_url = "http://api-adm.dharmap.com";
// let storage_path = "http://api-adm.dharmap.com/storage/images/item-img/";
// let appName = "ADM Dharma"

// export { url, socketurl, base_url, storage_path, appName, customerStyles };

let url;
let urlb;
let socketurl;
let customerStyles = require("./assets/custom.css");
let storage_path = "https://api-adm.kelola.dev/storage/images/item-img/";

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    url = 'http://localhost:8000/api';
    urlb = 'http://localhost:8000';
    socketurl = 'http://localhost:4001';
} else {
    url = 'https://api-adm.kelola.dev/api';
    urlb = 'https://api-adm.kelola.dev';
    socketurl = 'https://api-adm.kelola.dev';
}

const appName = 'Traceability 4W & 2W';
// const customerStyles = { 
//     control: (styles, {isFocused}) => ({ 
//         ...styles, 
//         backgroundColor: 'transparent',
//         boxShadow: isFocused ? '0 0.313rem 0.719rem rgba(0,123,255,.1), 0 0.156rem 0.125rem rgba(0,0,0,.06)' : 'none'
//     }),
// };

export { url, appName, customerStyles, urlb, socketurl, storage_path }
